import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { ENDPOINTS_ACHIEVEMENTS } from '../../config/';
import { localeData } from '../../locales/data';

import './AchievementsList.scss';
import { Popup } from 'semantic-ui-react';

interface AchievementsListProps {
  data: Immutable.List<any>;
}

const AchievementsListImpl = ({ data, intl }: AchievementsListProps & InjectedIntlProps) => (
  <div className="achievements-list__wrapper">
    {data && data.size > 0 ? (
      <div className="achievements-list__content">
        {data.map((item: any, index: number) => (
          <Popup
            key={item.get('id')}
            content={
              <>
                <div>{item.get('name')}</div>
              </>
            }
            on={'hover'}
            trigger={
              <div className="achievements-list__item" key={`user-profile__achievements-item-${index}`}>
                <img
                  className="achievements-list__icon"
                  src={`${ENDPOINTS_ACHIEVEMENTS.achievements}/${item.get('id')}/icon`}
                  alt={item.get('name')}
                />
              </div>
            }
          />
        ))}
      </div>
    ) : (
      <div>
        {intl.formatMessage({
          id: 'profile.info.noAchievements',
          defaultMessage: localeData.en['profile.info.noAchievements'],
        })}
      </div>
    )}
  </div>
);

export const AchievementsList = injectIntl(AchievementsListImpl);
